module.exports = {
	"$id": "header.json#",
	"$schema": "http://json-schema.org/draft-06/schema#",
	"type": "object",
	"required": [
		"name",
		"value"
	],
	"properties": {
		"name": {
			"type": "string"
		},
		"value": {
			"type": "string"
		},
		"comment": {
			"type": "string"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/har-schema/lib/header.json
// module id = 274
// module chunks = 0